import {Component, inject, input, signal} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {Card} from 'primeng/card';
import {
  TenderPhaseType,
  ProviderTenderControllerService,
  GetTenderDetailsRequestParams,
} from '@frontend/shared-api';
import {TabStatusEnum} from '../../../../../shared/tabs/tab-status.model';
import {TenderInvitationMailComponent} from '../../components/tender-invitation-mail/tender-invitation-mail.component';
import {rxResource} from '@angular/core/rxjs-interop';
import {LoadingComponent} from '../../../../../shared/components/loading/loading.component';
import {TenderRfcProjectConclusionComponent} from '../tender-rfc-project-conclusion/tender-rfc-project-conclusion.component';
import {WizardPhaseHeaderComponent} from '../../components/wizard-phase-header/wizard-phase-header.component';
import {TAB_INDICES} from './rfc-tender-wizard.types';
import {createTabManagementSignals} from '../../../../../shared/tabs/tab-utils';
import {TabStatusDirective} from '../../../../../shared/tabs/tab-status.directive';
import {TabsUnsavedRevealDirective} from '../../../../../shared/tabs/tabs-unsaved-reveal.directive';

@Component({
  selector: 'app-rfc-tender-wizard',
  imports: [
    TranslocoPipe,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    Card,
    TabPanel,
    TenderInvitationMailComponent,
    LoadingComponent,
    TenderRfcProjectConclusionComponent,
    WizardPhaseHeaderComponent,
    TabStatusDirective,
    TabsUnsavedRevealDirective,
  ],
  templateUrl: './rfc-tender-wizard.component.html',
})
export class RfcTenderWizardComponent {
  protected readonly TAB_INDICES = TAB_INDICES;

  private readonly providerTenderService = inject(ProviderTenderControllerService);

  protected readonly tabManagement = createTabManagementSignals();
  protected readonly mailPreviewTabStatus = signal(TabStatusEnum.COMPLETED);
  protected readonly projectConclusionTabStatus = signal(TabStatusEnum.NOT_STARTED);

  readonly tenderId = input.required<number>();

  protected readonly tenderDetailsResource = rxResource({
    params: (): GetTenderDetailsRequestParams => ({
      tenderId: this.tenderId(),
      tenderPhase: TenderPhaseType.RFC,
    }),
    stream: ({params: request}) => this.providerTenderService.getTenderDetails(request),
  });

  get activeTabIndex() {
    return this.tabManagement.activeTabIndex.asReadonly();
  }

  onTabChange(tabIndex: string | number): void {
    this.tabManagement.onTabChange(tabIndex);
  }
}
